import React from 'react';
import { motion } from 'framer-motion';
import { Repeat, PenTool, AlertTriangle, Clock, FolderSearch, Briefcase } from 'lucide-react';
const pains = [{
  Icon: Repeat,
  title: 'Repetís siempre las mismas clases',
  desc: 'Porque no tenés tiempo para preparar nuevas y terminás haciendo siempre lo mismo.'
}, {
  Icon: PenTool,
  title: 'Te cuesta crear nuevas secuencias',
  desc: 'Encontrar el equilibrio y la fluidez perfecta te lleva demasiadas horas.'
}, {
  Icon: AlertTriangle,
  title: 'Improvisás más de lo que te gustaría',
  desc: 'Llegás a la clase pensando en el camino qué vas a hacer hoy.'
}, {
  Icon: Clock,
  title: 'Perdés horas planificando',
  desc: 'Todas las semanas perdiendo horas de descanso intentando armar la clase.'
}, {
  Icon: FolderSearch,
  title: 'No encontrás material organizado',
  desc: 'Tenés capturas de pantalla y links que después no encontrás cuando estás armando la sesión.'
}, {
  Icon: Briefcase,
  title: 'Terminás trabajando fuera de horario',
  desc: 'Noches y fines de semana dedicados a pensar secuencias en lugar de descansar.'
}];
export function PainSection() {
  return <section className="py-24 lg:py-32 bg-white" data-id="element-135">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-136">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16 max-w-3xl mx-auto" data-id="element-137">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-brand-50 text-brand-700 font-medium text-xs uppercase tracking-widest mb-6 border border-brand-100/50" data-id="element-138">
            ¿Te pasa esto?
          </div>
          <h2 className="text-3xl md:text-5xl font-serif font-medium text-ink-900 mb-6 leading-tight tracking-tight" data-id="element-139">
            Si sos profesor, esto{' '}
            <span className="text-brand-600 italic" data-id="element-140">seguramente te pasa</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8" data-id="element-141">
          {pains.map((pain, i) => {
          const Icon = pain.Icon;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.06
          }} className="bg-[#FAF8F5] rounded-[2rem] p-8 hover:shadow-md transition-all duration-300" data-id="element-142">
                <div className="w-12 h-12 rounded-full bg-white text-brand-600 flex items-center justify-center mb-6 shadow-sm" data-id="element-143">
                  <Icon className="w-5 h-5" strokeWidth={1.5} data-id="element-144" />
                </div>
                <h3 className="font-serif font-medium text-xl text-ink-900 mb-3 leading-tight" data-id="element-145">
                  {pain.title}
                </h3>
                <p className="text-ink-600 text-sm leading-relaxed font-light" data-id="element-146">
                  {pain.desc}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}